<template>
  <header class="header-section">
    <div class="header-container">
      <div class="logo-container">
        <img src="../assets/logo.png" alt="Logo" class="logo" />
        <span class="brand-name">Photo enhancer - AI upscale</span>
      </div>
      
      <div class="header-content">
        <div class="header-text">
          <h1 class="header-title">{{ headerTitle }}</h1>
          <p class="header-description">{{ headerDescription }}</p>
        </div>
        <div class="header-image">
          <div class="image-container">
            <img src="../assets/main-image.png" alt="Photo Enhancer" class="hero-image" />
            <div class="floating-badge">
              <span>AI Powered</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'PhotoHeader',
  data() {
    return {
      headerTitle: 'What wonders can Photo Enhancer - AI upscale do for your photos?',
      headerDescription: 'Revive your old photos with Photo Enhancer - AI upscale. This tool can restore lost details and improve the quality of your blurry or low-quality photos, making them look stunning and crystal-clear. With just a few clicks, you can transform your photos into works of art and relive your cherished memories in better quality. Make your photos pop like they were taken by a professional! Try Photo Enhancer - AI upscale today.'
    }
  }
}
</script>

<style scoped>
.header-section {
  background-image: linear-gradient(to right, rgba(255,255,255,0.9), rgba(245,245,255,0.8)), url(../assets/background.png);
  background-size: cover;
  background-position: center;
  padding: 30px 0 80px;
  min-height: 540px;
  position: relative;
  overflow: hidden;
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
  z-index: 2;
}

.logo-container {
  display: flex;
  align-items: center;
  margin-bottom: 50px;
}

.logo {
  width: 50px;
  height: 50px;
  margin-right: 12px;
  filter: drop-shadow(0 2px 4px rgba(0,0,0,0.1));
}

.brand-name {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  letter-spacing: 0.5px;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-text {
  flex: 0 0 45%;
  animation: fadeInLeft 0.8s ease-out;
}

.header-title {
  font-size: 32px;
  color: #1a1a2e;
  margin-bottom: 24px;
  font-weight: 700;
  line-height: 1.3;
}

.header-description {
  font-size: 17px;
  line-height: 1.7;
  color: #444;
}

.header-image {
  flex: 0 0 50%;
  text-align: right;
  animation: fadeInRight 0.8s ease-out;
  position: relative;
}

.image-container {
  position: relative;
  display: inline-block;
}

.hero-image {
  max-width: 100%;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease;
}

.hero-image:hover {
  transform: translateY(-5px);
}

.floating-badge {
  position: absolute;
  top: -15px;
  right: -15px;
  background: linear-gradient(135deg, #ff6b4a, #b22541);
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-weight: bold;
  font-size: 14px;
  box-shadow: 0 4px 10px rgba(255, 107, 74, 0.3);
  animation: pulse 2s infinite;
}

@keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translateX(30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

/* Responsive Design */
@media (max-width: 992px) {
  .header-content {
    flex-direction: column;
  }
  
  .header-text {
    flex: 1;
    margin-bottom: 40px;
    text-align: center;
  }
  
  .header-image {
    flex: 1;
    text-align: center;
  }
  
  .hero-image {
    max-width: 85%;
  }
}

@media (max-width: 768px) {
  .header-section {
    padding: 20px 0 50px;
  }
  
  .logo-container {
    justify-content: center;
    margin-bottom: 30px;
  }
  
  .header-title {
    font-size: 26px;
    margin-bottom: 20px;
  }
  
  .header-description {
    font-size: 15px;
  }
  
  .hero-image {
    max-width: 100%;
  }
}
</style> 